export const theme = {
	buttonWrapper: 'qa-r-editor-btn-wrap',
	button: 'qa-r-editor-btn',
	actived: 'actived',
	disabled: 'disabled'
};



// WEBPACK FOOTER //
// ./lib/editor/MarkdownEditor/toolbar/theme.js